






import Vue, { PropType } from 'vue';
import { IUser } from '@/models/user';
import MentionUserPopover from '@/components/mention/MentionMenuPopover.vue';
import { vuetify } from '@/plugins';
import { delay } from 'lodash';
import mixins from '@/utils/mixins';
import functions from '@/mixins/functions';

const USER_POPOVER_DELAY = 200; //200ms

type VueHTMLElement = HTMLElement & HTMLSpanElement;

export default mixins(functions).extend({
  name: 'MentionProvider',

  props: {
    mentions: Array as PropType<IUser[]>
  },

  data() {
    return {
      hasAddedLazyPopovers: false
    };
  },

  methods: {
    getUserLinkNode(node: Element) {
      return node.closest<VueHTMLElement>('span.mention[data-mention]');
    },

    createPopover(el: VueHTMLElement, userId: number) {
      const mention = this.mentions.find(mention => {
        return mention.id == userId;
      });
      // if no mention then we cant show a mention popover
      if (!mention) return;

      const UserPopoverComponent = Vue.extend(MentionUserPopover);
      // type cast to solve the rendering of menu component
      return new UserPopoverComponent({
        vuetify: vuetify,
        propsData: {
          target: el,
          mention: mention,
          value: true
        }
      });
    },

    launchPopover(el: VueHTMLElement) {
      const user = el.getAttribute('data-mention');

      const popoverInstance: Vue | undefined = this.createPopover(
        el,
        Number(user)
      );

      if (!popoverInstance) return;

      popoverInstance.$mount();

      // destroy instance when menu closes to avoid rerendering menu component
      popoverInstance.$on('menu:close', () => {
        delay(() => {
          popoverInstance.$destroy();
        }, USER_POPOVER_DELAY * 2);
      });
    },

    lazyLaunchPopover(event: Event) {
      const userLink = this.getUserLinkNode(event.target as VueHTMLElement);
      if (userLink) {
        this.launchPopover(userLink);
      }
    },

    debounceLazyLaunchPopover(event: Event) {
      return this.debounce(this.lazyLaunchPopover, USER_POPOVER_DELAY)(event);
    },

    userPopoverInitialization() {
      if (!this.hasAddedLazyPopovers) {
        this.$el.addEventListener('mouseover', event =>
          this.debounceLazyLaunchPopover(event)
        );
      }
      this.hasAddedLazyPopovers = true;
    }
  },

  mounted() {
    this.userPopoverInitialization();
  }
});
